import React from "react";
import * as C from "vonnegut.components";
import { observer, inject } from "mobx-react";
import * as Icon from "react-feather";

const QuestionListItemActions = ({ question, store }) => {
  const { $question, $locale, $router, $user, $group } = store;
  return (
    $router.mode === "edit" &&
    question.isEditable &&
    ($user.sessionUser.isVerifiedCreator ||
      ($user.sessionUser.isVerifiedMentor &&
        $group.selected &&
        $group.selected._key === question.createdForGroup)) && (
      <React.Fragment>
        {!$question.dragFrom && (
          <div className="action-new">
            <C.Button
              icon={<Icon.Plus className="color-white" />}
              title={`Nieuwe ${
                question.type === "fieldset" ? "Sectie" : "Vraag"
              }`}
              onClick={() => {
                $locale.clearSelectedList();
                $question.setSelected({
                  _key: "new",
                  order: Number(question.order) + 100,
                  parentKey: question.parentKey || null,
                  _tempSiblingKeysAfter: question.siblingKeysAfter,
                  ...(question.type === "fieldset" && { type: "fieldset" })
                });
              }}
              className="bg-primary no-label small "
            />
          </div>
        )}
        <div className="flex bg-primary absolute actions">
          {question.type !== "fieldset" && (
            <C.Button className="btn bg-primary cursor-move no-label">
              <Icon.Move size={18} color="white" />
            </C.Button>
          )}
          {question.type === "fieldset" && (
            <C.Button
              className="btn bg-primary no-label"
              onClick={() => $question.change("openDragDialog", question._key)}
            >
              <Icon.Menu size={18} color="white" />
            </C.Button>
          )}
          <C.Button
            className="btn bg-primary no-label "
            onClick={() =>
              $question.setSelected($question.list.get(question._key))
            }
          >
            <Icon.Edit2 size={18} color="white" />
          </C.Button>
          {question.type !== "fieldset" && (
            <C.Button
              className="btn bg-primary no-label"
              onClick={e => {
                $question.change("duplicateFrom", question._key);
                $question.setSelected(
                  $question.list.get($question.duplicateFrom)
                );
              }}
            >
              <Icon.Copy size={18} color="white" />
            </C.Button>
          )}
          <C.Button
            className="btn bg-primary no-label "
            onClick={() => {
              if(question.getResponses().length) {
                $question.change("confirmDeleteQuestion", question._key);
              } else{
                $question.list.get(question._key).fsDelete();
              } 
            }}
          >
            <Icon.Trash size={18} color="white" />
          </C.Button>
        </div>
      </React.Fragment>
    )
  );
};

export default inject("store")(observer(QuestionListItemActions));
